import Body from "../../../../../../material/skeleton/Body";
import Footer from "../../../../../../material/skeleton/Footer";
import QuotationItemList from "./QuotationItemList";
import Box from "@mui/material/Box";
import {CheckCircle} from "@mui/icons-material";
import {Button} from "@mui/material";
import SecondAppointment from "./SecondAppointment";
import {useRef, useState} from "react";
import ClientContact from "./ClientContact";
import useQualityInspectionRepository from "../../../../../../repository/emergency/useQualityInspectionRepository";
import QualityInspection from "../../../../../../entity/emergency/QualityInspection";
import NotifySupportedPrice from "./NotifySupportedPrice";
import useInterventionRepository from "../../../../../../repository/emergency/useInterventionRepository";
import parameter from "../../../../../../enum/parameter";
import useAlert from "../../../../../../use/useAlert";

export default function ({qualityInspectionId, clientId, interventionId, orderId}) {
    const alert = useAlert();
    const qualityInspectionRepository = useQualityInspectionRepository();
    const interventionRepository = useInterventionRepository();
    const quotationPayload = useRef();
    const quotationItemPayload = useRef();
    const secondAppointmentInput = useRef();
    const clientEmailInput = useRef();
    const clientPhone1Input = useRef();
    const [loading, setLoading] = useState(false);

    const handleQuotationPayloadChange = data => quotationPayload.current = data;
    const handleQuotationItemPayloadChange = data => quotationItemPayload.current = data;
    const handleSecondAppointmentChange = date => secondAppointmentInput.current = date;
    const handleClientPhone1Change = data => clientPhone1Input.current = data;
    const handleClientEmailChange = data => clientEmailInput.current = data;

    const nextStep = async () => {
        setLoading(true);

        let items = await interventionRepository.getSupportedPriceByOrder(orderId);

        const result = items.map(i => {
            return {
                name: i.name,
                description: null,
                price: i.price,
                quantity: 1,
                standardized_item_id: null,
                default_item_id: i.default_item_id
            }
        });

        quotationItemPayload.current.forEach(i => result.push(i));


        const res = await qualityInspectionRepository.update(qualityInspectionId, "current_step", {
            quality_inspection: {
                current_step: QualityInspection.STEP_QUOTATION
            },
            quotation: quotationPayload.current,
            quotation_item: result,
            client: {
                phone_1: clientPhone1Input.current,
                email: clientEmailInput.current
            },
            intervention: {
                second_appointment: secondAppointmentInput.current
            }
        });

        if (!res) setLoading(false);
    }

    return (
        <>
            <Body sx={{pt: 1, pb: 2}}>
                <Box>
                    <NotifySupportedPrice/>
                </Box>
                <Box mt={1} px={1}>
                    <QuotationItemList
                        orderId={orderId}
                        onQuotationPayloadChange={handleQuotationPayloadChange}
                        onQuotationItemPayloadChange={handleQuotationItemPayloadChange}
                    />
                </Box>
                <Box mt={5} px={1}>
                    <SecondAppointment onChange={handleSecondAppointmentChange}/>
                </Box>
                <Box mt={5} px={1}>
                    <ClientContact
                        clientId={clientId}
                        onPhone1Change={handleClientPhone1Change}
                        onEmailChange={handleClientEmailChange}
                    />
                </Box>
            </Body>
            <Footer>
                <Button
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    variant="contained"
                    fullWidth
                    size={"large"}
                    onClick={nextStep}
                    disabled={loading}
                    data-test="button-next-step"
                >
                    Valider
                </Button>
            </Footer>
        </>
    );
}